import React from 'react'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import {faCheck} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {pickAttributes} from '../../../helpers/utils'

export default function EditableCaption(props) {
  const [value, setValue] = React.useState(props.value)
  const inputRef = React.useRef()

  React.useEffect (() => {
    setValue(props.value)
  },[props.value])

  React.useEffect(() => {
    if (props.editing) {
      setTimeout(() => {
        inputRef.current.focus()
      }, 10)
    }
  }, [props.editing])

  function handleCancel(e) {
    e.stopPropagation()
    setValue(props.value)
    props.onCancel && props.onCancel()
  }

  function handleConfirm (e) {
    e.stopPropagation()
    props.onConfirm && props.onConfirm(value)
  }

  function handleClickAway (e) {
    props.cancelOnClickAway
      ? handleCancel(e)
      : handleConfirm(e)
  }

  const controlAttributes = pickAttributes(props, 'control')
  const inputAttributes = pickAttributes(props, 'input')
  const labelAttributes = pickAttributes(props, 'label')
  const addornmentAttributes = pickAttributes(props, 'addornment')

  return (
    <div className={props.className}>
      {props.editing && (
        <ClickAwayListener onClickAway={handleClickAway} mouseEvent='onMouseDown' touchEvent='onTouchStart'>
          <div
            className="control"
            onClick={e => e.stopPropagation()}
            {...controlAttributes}
          >
            <div className="input-wrapper">
              <input
                className="input"
                type="text"
                value={value}
                pattern={props.pattern}
                ref={inputRef}
                onKeyDown={e => {
                  e.key == 'Enter' && handleConfirm(e)
                  e.key == 'Escape' && handleCancel(e)
                }}
                onChange={e => setValue(e.target.value)}
                {...inputAttributes}
              />
            </div>
            <span className="addornment" {...addornmentAttributes} onClick={handleConfirm}>
              <FontAwesomeIcon icon={faCheck} />
            </span>
          </div>
        </ClickAwayListener>
      )}
      {!props.editing && (<div className="label" {...labelAttributes} >{props.value}</div>)}
    </div>
  )
}
